import { createBrowserRouter } from "react-router"
import type { JSX } from "react"
import { lazy, Suspense } from "react"

import Layout from "./components/Layout/Layout"
import RouterLayout from "./components/RouterLayout/index"
import Index from "./pages/Index/index"
import News from "./pages/News"
import Detail from "./pages/News/detail"
import FootDetail from "./pages/Footmgn/detail"
import Notfound from "./pages/Notfound"
import Webc from "./pages/webc"
// const News = lazy(() => impasync ort('./pages/News'))
// const Detail = lazy(() => import('./pages/News/detail'))
// const FootDetail = lazy(() => import('./pages/Footmgn/detail'))
// const Notfound = lazy(() => import('./pages/Notfound'))

// 通用 loading
const withSuspense = (Component: JSX.Element) => (
  <Suspense fallback={<div>Loading...</div>}>{Component}</Suspense>
)

// const router = createBrowserRouter([
//   {
//     path: '/',
//     element: <Index />,
//   },
//   {
//     path: '/news',
//     element: withSuspense(<News />),
//   },
//   {
//     path: '/detail',
//     element: withSuspense(<Detail />),
//   },
//   {
//     path: '/fmgndetail',
//     element: withSuspense(<FootDetail />),
//   },
//   {
//     path: '*',
//     element: (
//       <Layout>
//         {withSuspense(<Notfound />)}
//       </Layout>
//     ),
//   },
// ])

// const router = createBrowserRouter([
//   {
//     path: '/',
//     element: <Index />,
//   },
//   {
//     path: '/news',
//     element:<News />,
//   },
//   {
//     path: '/detail',
//     element: <Detail />,
//   },
//   {
//     path: '/fmgndetail',
//     element: <FootDetail />,
//   },
//   {
//     path: '*',
//     element: (
//       <Layout>
//         <Notfound />
//       </Layout>
//     ),
//   },
// ])

const router = createBrowserRouter([
  {
    path: "/",
    element: <RouterLayout />, // 统一 RouterLayout
    children: [
      {
        index: true,
        element: <Webc />,
      },
      // {
      //   path: "pc",
      //   element: <Webc />,
      // },
      // {
      //   path: "news",
      //   element: <News />,
      // },
      // {
      //   path: "detail/:id",
      //   element: <Detail />,
      // },
      // {
      //   path: "fmgndetail/:id",
      //   element: <FootDetail />,
      // },
      {
        path: "*",
        element: (
          <Layout>
            <Notfound />
          </Layout>
        ),
      },
    ],
  },
],{
  // 关键：设置 basename
  //basename: '/official'
})

export default router
